import { createSlice } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import { fetchEmployeeStatuses, fetchEmployeeMaritalStatuses } from './employeeStatuses.actions';
import { EmployeeStatusesState } from './employeeStatuses.types';

const initialState: EmployeeStatusesState = {
  employeeStatuses: [],
  employeeMaritalStatuses: [],
  fetchEmployeeStatusesStatus: fetchStatuses.idle,
  fetchEmployeeMaritalStatusesStatus: fetchStatuses.idle,
  error: null,
};

const employeeStatusesSlice = createSlice({
  name: 'employeeStatuses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // === FETCH EMPLOYEE STATUSES ===
    builder.addCase(fetchEmployeeStatuses.pending, (state) => {
      state.error = null;
      state.fetchEmployeeStatusesStatus = fetchStatuses.pending;
    });
    builder.addCase(fetchEmployeeStatuses.fulfilled, (state, action) => {
      state.fetchEmployeeStatusesStatus = fetchStatuses.success;
      // API returns: { data: { data: [...] }, status, message }
      state.employeeStatuses = action.payload.data?.data ?? [];
    });
    builder.addCase(fetchEmployeeStatuses.rejected, (state, action) => {
      state.fetchEmployeeStatusesStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    // === FETCH EMPLOYEE MARITAL STATUSES ===
    builder.addCase(fetchEmployeeMaritalStatuses.pending, (state) => {
      state.error = null;
      state.fetchEmployeeMaritalStatusesStatus = fetchStatuses.pending;
    });
    builder.addCase(fetchEmployeeMaritalStatuses.fulfilled, (state, action) => {
      state.fetchEmployeeMaritalStatusesStatus = fetchStatuses.success;
      // API returns: { data: { data: [...] }, status, message }
      state.employeeMaritalStatuses = action.payload.data?.data ?? [];
    });
    builder.addCase(fetchEmployeeMaritalStatuses.rejected, (state, action) => {
      state.fetchEmployeeMaritalStatusesStatus = fetchStatuses.rejected;
      state.error = action.error;
    });
  },
});

export default employeeStatusesSlice.reducer;
